export default {
  dragOrClick: 'Przeciągnij plik tutaj lub kliknij, aby przesłać - maksymalnie {maxSize} | Przeciągnij pliki tutaj lub kliknij, aby przesłać - maksymalnie {maxSize} na plik',
  uploadError: 'Plik nie został przesłany z powodu nieprawidłowego formatu lub rozmiaru: | Niektóre pliki nie zostały przesłane z powodu nieprawidłowego formatu lub rozmiaru:',
  dragError: {
    onDragTooManyFiles: 'Można przesłać tylko jeden plik jednocześnie.',
    onDragSomeUnsupportedMimetype: 'Niektóre z wybranych plików mają nieobsługiwane formaty.',
    onDragAllUnsupportedMimetype: 'Żaden z formatów plików nie jest obsługiwany.',
    onDragUnsupportedMimetype: 'Format pliku nie jest obsługiwany.',
  },
};
